$.ajax({
    type: "get",
    data: `page=1&sort_by_status=active&result_per_page=${$("#result_per_page").find(":selected").val()}&sort_by=${$("#sort_by").find(":selected").val()}`,
    url: "/a/hoody/auctions/fetch_auction_items"
})

$("#sort_by_type").on("change", function () {
    set_filters()
})

$("#sort_by").on("change", function () {
    set_filters()
})

$("#filter_by_status").on("change", function () {
    set_filters()
})

$("#result_per_page").on("change", function () {
    set_filters()
})

$("#sort_by_category").on("change", function () {
    set_filters()
})


function set_filters() {
    let sortByStatus = $("#filter_by_status").find(":selected").val() ? $("#filter_by_status").find(":selected").val() : "active";
    let data = `query=${$("#search_by_title").val()}&category_id=${$("#sort_by_category").find(":selected").val()}&sort_by_type=${$("#sort_by_type").find(":selected").val()}&sort_by=${$("#sort_by").find(":selected").val()}&sort_by_status=${sortByStatus}&result_per_page=${$("#result_per_page").find(":selected").val()}`
    fetch_consignments(data)
}


$("#search_by_title").on("keyup", function () {
    set_filters();
})
